
import React from 'react';
import { Route } from 'react-router-dom';
import Configuration from "../component/Configuration";
import Config from "../Config";

export default [
    <Route exact path={Config.CONFIGURATION_ROUTE} component={Configuration} />,
];
